


























































import {Component, Prop, Vue} from "vue-property-decorator";
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

@Component({
    components: {Swiper, SwiperSlide},
})
export default class projectManage extends Vue {

    TSSswiperOption = {
        slidesPerView: 8,
        spaceBetween: 0,
        breakpoints: {
            300: {
                slidesPerView: 2.5
            },
            480: {
                slidesPerView: 3.5
            },
            768: {
                slidesPerView: 4.5
            },
            992: {
                slidesPerView: 6
            },
            1200: {
                //slidesPerView: 7
            }
        }
    }

    async mounted() {
        const projectId = this.$route.params.id;
        await this.$store.dispatch("loginState");
        await this.$store.dispatch("project", projectId);

    }


};
